/**
 * convert BASE64 PDF content back to byte stream with correct PDF file size
 */
export const base64ToArrayBuffer = (data: string): Uint8Array<ArrayBuffer> => {
	const binaryString = window.atob(data)
	const bytes = new Uint8Array(binaryString.length)

	for (let i = 0; i < binaryString.length; i++) {
		bytes[i] = binaryString.charCodeAt(i)
	}
	return bytes
}
